import { AppEvent } from './../../../app_bus/app-event';
export class ToneEndedEvent extends AppEvent {
    constructor(toneEntry) {
        super("Tone ended");
        this.toneEntry = toneEntry;
    }
}
//# sourceMappingURL=tone-ended-event.js.map